import { useState } from "react";

function hasContextValue(value) {
  return value != null && String(value).trim() !== "";
}

/**
 * Collapsible localization / submission metadata for admin lead and seller views.
 */
export default function SubmissionContextSection({ context = {}, title = "Submission Context" }) {
  const [open, setOpen] = useState(false);

  const fields = [
    { key: "locale", label: "Locale" },
    { key: "language", label: "Language" },
    { key: "displayCurrency", label: "Display Currency" },
    { key: "routeLocale", label: "Route Locale" },
    { key: "clientViewSlug", label: "Client View" },
    { key: "fxSource", label: "FX Source" },
    { key: "fxStale", label: "FX Stale", format: (value) => (value == null ? null : value ? "Yes" : "No") },
    { key: "pageUrl", label: "Submitted URL" },
    { key: "sourcePage", label: "Source Page" },
    { key: "currentPath", label: "Current Path" },
  ];

  const visible = fields.filter(({ key, format }) => {
    const raw = context[key];
    const value = format ? format(raw) : raw;
    return hasContextValue(value);
  });

  if (!visible.length) return null;

  return (
    <section className="dealer-state-box">
      <button
        type="button"
        className="dealer-portal-btn"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
      >
        {open ? "Hide" : "Show"} {title}
      </button>
      {open ? (
        <dl className="admin-table-subtext" style={{ marginTop: "0.75rem" }}>
          {visible.map(({ key, label, format }) => {
            const raw = context[key];
            const value = format ? format(raw) : raw;
            return (
              <div key={key}>
                <dt>
                  <strong>{label}</strong>
                </dt>
                <dd>{value}</dd>
              </div>
            );
          })}
        </dl>
      ) : null}
    </section>
  );
}
